export default "__VITE_ASSET__BhFP8vwV__"